import React from 'react'
import { Body, closeAnimation, Header, Main } from '../Layout/Layout';
import Button from '../Button/Button';

function GoogleDocsEditor({ setViewDocs, viewDocs }: { setViewDocs: any, viewDocs: any }) {
    return (
        <Main width='100vw' height='100vh' bgColor='white'>
            <Header height='100'>
                <Button
                    type='close'
                    onClick={() => {
                        closeAnimation();
                        setTimeout(() => { setViewDocs('') }, 500);
                    }}>
                    Close
                </Button>
            </Header>
            <Body>
                <iframe src={`https://docs.google.com/document/d/${viewDocs}/view`} className='w-full h-full' />
            </Body>
        </Main>
    )
}

export default GoogleDocsEditor